<template>
  <div class="container">
    <a v-if="chatEnabled" class="action" href="#" @click.prevent="loadAndOpenChat">
      <div class="description">
        <span>
          {{ $t('webstars.buttons.chat.title') }}
        </span>
      </div>
    </a>
    <ChatModal 
    v-if="showModal" 
    :model="model" 
    :chat="chat"
    :subscription_plans="chat.subscription_plans"
    @cancel="showModal = false" 
    />
  </div>
</template>
<script>
import resources from "../../resources";
import ChatModal from "../ChatModal"
export default {
  components: { ChatModal },
  props: {
    model: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      showModal: false,
      loadingModel: false,
      errorModel: false,
      loadingChat: false,
      languageChanged: false,
      chat: null
    };
  },
  methods: {
    loadChatModel(id) {
      this.loadingModel = true;
      this.errorModel = false;

      let data = { id: id };
      return resources.chatModel.apiReadPost(data).then((response) => {
        this.loadingChat = false;
        this.chat = response.data.data;
        if(!this.chat.subscription_plans) {
          this.chat.subscription_plans = [];
        }
      }).catch((error) => {
        this.loadingChat = true;
      });
    },
    openChat() {
      switch (this.chat.case) {
        case 'open_chat':
          window.location = this.chat.url;
          break;

        case 'modal_login':
        case 'modal_subscription':
          this.showModal = true;
          break;

        default:
          break;
      }
    },
    loadAndOpenChat() {
      this.loadChatModel(this.model.id).then(() => {
        this.openChat();
      });
    }
  },
  computed: {
    chatEnabled() {
      //si tiene seteado en el .env y es true, el model tiene chat_enabled (chat_setting_enabled = 1 + approved = 1 )
      const chatEnabled = !!(process.env.VUE_APP_CHAT_ENABLED && process.env.VUE_APP_CHAT_ENABLED === 'true');
      return chatEnabled && this.model.chat_enabled;
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';
@import '../../styles/classes';

.container {
  display: flex;
}

.action {
  @extend %fresh-btn;
  border-radius: 0.5rem;
  padding-inline: 0.25em;

  .description {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;

    span {
      font-size: 600;
      font-size: .75em;
      text-wrap: nowrap;
    }
  }
}

.chat-subtitle-username {
  color: var(--pallete_main_color);
}
</style>